import { Injectable } from '@angular/core';
import API, {graphqlOperation} from "@aws-amplify/api-graphql";


export type ListTemplatesQuery = {
  __typename: "ModelTemplateConnection";
  items: Array<{
    __typename: "Template";
    id: string;
    _id?: string | null;
    _name?: string | null;
    _description?: string | null;
    _document?: string | null;
    _company?: string | null;
    _date?: string | null;
    _invoice_date?: string | null;
    _due_date?: string | null;
    _price?: string | null;
    _vat?: string | null;
    _total?: string | null;
    _invoice_number?: string | null;
    _pib?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ModelTemplateFilterInput = {
  id?: ModelIDInput | null;
  _id?: ModelStringInput | null;
  _name?: ModelStringInput | null;
  _description?: ModelStringInput | null;
  _document?: ModelStringInput | null;
  _company?: ModelStringInput | null;
  _date?: ModelStringInput | null;
  _invoice_date?: ModelStringInput | null;
  _due_date?: ModelStringInput | null;
  _price?: ModelStringInput | null;
  _vat?: ModelStringInput | null;
  _total?: ModelStringInput | null;
  _invoice_number?: ModelStringInput | null;
  _pib?: ModelStringInput | null;
  and?: Array<ModelTemplateFilterInput | null> | null;
  or?: Array<ModelTemplateFilterInput | null> | null;
  not?: ModelTemplateFilterInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};


@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor() { }

  async ListTemplates(
    filter?: ModelTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTemplatesQuery> {
    const statement = `query ListTemplates($filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
        listTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            description
            template
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTemplatesQuery>response.data.listTemplates;
  }
}
